import { render, staticRenderFns } from "./DNSCloakInstallInstructions.vue?vue&type=template&id=b9e74e3e&scoped=true&"
import script from "./DNSCloakInstallInstructions.vue?vue&type=script&lang=js&"
export * from "./DNSCloakInstallInstructions.vue?vue&type=script&lang=js&"
import style0 from "./DNSCloakInstallInstructions.vue?vue&type=style&index=0&id=b9e74e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e74e3e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VIcon,VImg,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9e74e3e')) {
      api.createRecord('b9e74e3e', component.options)
    } else {
      api.reload('b9e74e3e', component.options)
    }
    module.hot.accept("./DNSCloakInstallInstructions.vue?vue&type=template&id=b9e74e3e&scoped=true&", function () {
      api.rerender('b9e74e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DnsCloak/DNSCloakInstallInstructions.vue"
export default component.exports